import { useState, useEffect } from 'react';

 const isToExpand = () => {
   return false;
 };

 const hasSafeArea= () => {
   let barHeight = getComputedStyle(document.documentElement).getPropertyValue("--sab");
   return (barHeight && barHeight !== '0px');
 };

 export const useToExpandFooter =() => {
  let [toExpand, setToExpand] = useState(isToExpand());

  useEffect(() => {

    let isMounted = true; 

    const resizeListener = () => {
      if(isMounted){  
        // change width from the state object
        setTimeout(()=>{
          setToExpand(isToExpand());
        });
       
      }
    };
    // set resize listener
    window.addEventListener('resize', resizeListener);

    // clean up function
    return () => {
      // remove resize listener
      isMounted = false;
      window.removeEventListener('resize', resizeListener);
    }
  }, [])

  return toExpand;
}